const API = {
  LOG_IN: "/company/login",
  ADMIN_LOG_IN: "/admin/company-login",
  FORGOT_PASSWORD: "/forgot_password",
  PROFILE: "/company/user_details",
  INVITATION: "/company/authentication_details",
  MASTER_PROFILE: "/company/profile",
  GET_MANAGERS: "/company/users",
  CREATE_MANAGER: "/company/create_user",
  DELETE_MANAGER: "/company/delete_user",
  GET_EMPLOYEES: "/company/employees",
  GET_ONBOARD_EMPLOYEES: "/company/survey-employees",
  CREATE_EMPLOYEE: "/company/invite_user",
  DELETE_EMPLOYEE: "/company/deactivate_employee",
  GET_DEPARTMENTS: "/company/departments",
  GET_COUNTRIES: "/country",
  GET_QUOTE: "/get_quote",
  UPGRADE_PLAN: "/upgrade",

  GET_SURVEYS: "/v1/company/survey_overview",
  EXPORT_SURVEY: "/v1/company/export-survey",
  CHANGE_SURVEY_STATUS: "/v1/company/change_survey_status",
  GET_QUESTIONNAIRE: "/v2/get-survey",
  GET_QUESTIONS: "/v1/company/get-survey-questions",
  SAVE_SURVEY: "/v1/company/save-survey-questions",
  SURVEY_INSIGHTS: "/v1/company/survey_insight",
  SURVEY_RESPONSE: "/v1/company/free-text-analytics",
  SUBMIT_SURVEY: "/v1/survey-response",
  IS_SURVEY_SUBMITTED: "/v1/is-survey-submitted",

  GET_MINDFULNESS_DATA: "/v1/company/company_dashboard",
  GET_MINDFULNESS_ACTIVITY_INSIGHT: "/v1/company/activity_level",
  GET_MINDFULNESS_LEADING_ISSUES_INSIGHT: "/v1/company/leading_issues",
  GET_MINDFULNESS_CONCERNING_ISSUES_INSIGHT:
    "/v1/company/concerning_issues_stats",
  GET_MINDFULNESS_PRIORITY_ISSUES_INSIGHT: "/v1/company/priority_issues_stats",
  GET_MINDFULNESS_SUPPORT_SATISFACTION_INSIGHT:
    "/v1/company/support_satisfaction_insights",
  GET_MINDFULNESS_WELLNESS_SUPPORT_INSIGHT:
    "/v1/company/wellness_support_insights",
  GET_MINDFULNESS_COMPANY_MOOD_INSIGHT: "/v1/company/company_mood",
  GET_MINDFULNESS_PROFESSIONALS_INSIGHT: "/v1/company/professionals_insights",
  GET_MINDFULNESS_CONVERSATIONAL_INSIGHT: "/v1/company/text-analytics",

  GET_PHYSICAL_DASHBOARD: "/v1/company/physical_dashboard",
  GET_PHYSICAL_WELLNESS_INSIGHTS: "/v1/company/physical_wellness_insights",
  GET_PHYSICAL_WATER_INTAKE_INSIGHTS:
    "/v1/company/physical_water_intake_insights",
  GET_PHYSICAL_CALORIE_INSIGHTS: "/v1/company/physical_calorie_intake_insights",
  GET_PHYSICAL_SLEEP_INSIGHTS: "/v1/company/physical_sleep_time_insights",
  GET_PHYSICAL_STEPS_INSIGHTS: "/v1/company/physical_step_count_insights",
  GET_PHYSICAL_SPORTS_ACTIVITY_INSIGHTS:
    "/v1/company/physical_sports_activity_insights",
  GET_PHYSICAL_HEALTHY_INSIGHTS: "/v1/company/physical_healthy_insights",
  GET_PHYSICAL_HEALTHY_MONTHLY_INSIGHTS:
    "/v1/company/physical_healthy_monthly_insights",
  GET_PHYSICAL_BLOOD_PRESSURE: "/v1/company/blood-pressure",


  GET_COMPANY_MANAGERS: "/company/managers",
  TASKS: "/tasks",
};

export default API;
